import React, { Component } from 'react';
import { translate } from '../../../../i18n/i18n';
import { inject, observer } from 'mobx-react';

@translate()
@inject('store')
@observer
class CraneBookingTypeTab extends Component {
    constructor() {
        super();
        this.state= {
            type: null,
            price: null
        }
    }

    componentDidMount() {
        this.setState({
            type: this.props.store.craneBooking.form.type,
            price: this.props.store.craneBooking.form.price,
        })
    }

    setBookingType(type, price) {
        this.props.store.craneBooking.setFormValue('type', type);
        this.props.store.craneBooking.setFormValue('price', price);
        this.setState({
            type,
            price
        });
        this.props.store.craneBooking.savePaymentRequest('craneBooking', price);
    }
    render() {
        return (
            <div className='vertical-centered'>
                <div className="selection-btn-container">
                    <button
                        onClick={()=>this.setBookingType(0, 995)}
                        className={`${this.state.type === 0 ? 'modal-form-btn-active' : 'modal-form-btn'}`}
                    >
                        Op til 5 tons uden mast (995 kr)
                    </button>
                </div>
                <div className="selection-btn-container">
                    <button
                        onClick={()=>this.setBookingType(1, 1295)}
                        className={`${this.state.type === 1 ? 'modal-form-btn-active' : 'modal-form-btn'}`}
                    >
                        Op til 5 tons med mast (1295 kr)
                    </button>
                </div>
                <div className="selection-btn-container">
                    <button
                        onClick={()=>this.setBookingType(2, 1595)}
                        className={`${this.state.type === 2 ? 'modal-form-btn-active' : 'modal-form-btn'}`}
                    >
                        5-10 tons uden mast (1595 kr)
                    </button>
                </div>
                <div className="selection-btn-container">
                    <button
                        onClick={()=>this.setBookingType(3, 1895)}
                        className={`${this.state.type === 3 ? 'modal-form-btn-active' : 'modal-form-btn'}`}
                    >
                        5-10 tons med mast (1895 kr)
                    </button>
                </div>
            </div>
        )
    }
}

export default CraneBookingTypeTab;
